import { Injectable } from '@angular/core';
import { IAppManagerResponse } from '../model/app-manager.respose.interface';
import { AppManagerService } from './app-manager.service';

@Injectable({
    providedIn: 'root'
})
export class TraceService {

    private static readonly CONST_CLASSNAME = 'LWAppManager.Common.LWTrace';
    private static readonly CONST_TRANS_CLASSNAME = 'LWAppManager.Common.LWTransaction';
    private static readonly CONST_KEY = 'Common';

    constructor(private appManagerService: AppManagerService) { }

    public transactionStart(transactionType: string, siteID: string, deviceID: string, updUserID: string, transactionBy: string) {
        try {
            const reqParams = { TransactionType: transactionType, SiteID: siteID, DeviceID: deviceID, UpdUserID: updUserID, TransactionBy: transactionBy, };
            return this.appManagerService.callSignalR(TraceService.CONST_KEY, TraceService.CONST_TRANS_CLASSNAME, 'Start', JSON.stringify(reqParams))
                .then((result: IAppManagerResponse) => {
                    return result;
                });
        } catch (e) { return }
    }

    public transactionDone(transactionType: string) {
        try {
            const reqParams = { TransactionType: transactionType, };
            return this.appManagerService.callSignalR(TraceService.CONST_KEY, TraceService.CONST_TRANS_CLASSNAME, 'Done', JSON.stringify(reqParams))
                .then((result: IAppManagerResponse) => {
                    return result;
                });
        } catch (e) { return }
    }

    public sessionStart(loginWithDeviceUser: boolean, invoker: string, severity: string, isUrgentTrace: boolean, pageTitle: string) {
        try {
            const reqParams = { IsDoDeviceUserLogIn: loginWithDeviceUser, Invoker: invoker, Severity: severity, IsUrgentTrace: isUrgentTrace, PageName: pageTitle, };
            return this.appManagerService.callSignalR(TraceService.CONST_KEY, TraceService.CONST_CLASSNAME, 'AppSessionStart', JSON.stringify(reqParams))
                .then((result: IAppManagerResponse) => {
                    return result;
                });
        } catch (e) { return }
    }

    public pageNavigateStart(pageTitle: string) {
        try {
            const methodName = 'PageNavigateStart';
            return this.appManagerService.callSignalR(TraceService.CONST_KEY, TraceService.CONST_CLASSNAME, methodName, pageTitle)
                .then((result: IAppManagerResponse) => {
                    return result;
                });
        } catch (error) {
            console.log('Error while calling callSignalR callSignalR method - ' + JSON.stringify(error));
            return 
        }
    }

    public pageNavigation(caption: string, invoker: string, severity: string, pageTitle: string, navUrl: string, isUrgentTrace: boolean) {
        try {
            const reqParams = { Invoker: invoker, Severity: severity, IsUrgentTrace: isUrgentTrace, PageName: pageTitle, NavUrl: navUrl, };
            return this.appManagerService.callSignalR(TraceService.CONST_KEY, TraceService.CONST_CLASSNAME, 'PageNavigation', JSON.stringify(reqParams))
                .then((result: IAppManagerResponse) => {
                    return result;
                });
        } catch (e) { return }
    }

    public externalWebAPI(invoker: string, severity: string, pageTitle: string, isUrgentTrace: boolean, payload: string, response: string) {
        try {
            const reqParams = { Invoker: invoker, Severity: severity, IsUrgentTrace: isUrgentTrace, PageName: pageTitle, Payload: payload, Response: response };
            return this.appManagerService.callSignalR(TraceService.CONST_KEY, TraceService.CONST_CLASSNAME, 'ExternalAPICall', JSON.stringify(reqParams))
                .then((result: IAppManagerResponse) => {
                    return result;
                });
        } catch (e) { return }
    }

    public userAction(caption: string, invoker: string, severity: string, pageTitle: string, isUrgentTrace: boolean, message: string) {
        try {
            const reqParams = { Caption: caption, Invoker: invoker, Severity: severity, IsUrgentTrace: isUrgentTrace, PageName: pageTitle, Message: message, };
            return this.appManagerService.callSignalR(TraceService.CONST_KEY, TraceService.CONST_CLASSNAME, 'UserAction', JSON.stringify(reqParams))
                .then((result: IAppManagerResponse) => {
                    return result;
                });
        } catch (e) {  return }
    }

    public deviceCallReq(device: string, action: string, payload: string, invoker: string, severity: string, pageTitle: string, isUrgentTrace: boolean) {
        try {
            const reqParams = { Device: device, Action: action, Payload: payload, Invoker: invoker, Severity: severity, IsUrgentTrace: isUrgentTrace, PageName: pageTitle, };
            return this.appManagerService.callSignalR(TraceService.CONST_KEY, TraceService.CONST_CLASSNAME, 'DeviceCallReq', JSON.stringify(reqParams))
                .then((result: IAppManagerResponse) => {
                    return result;
                });
        } catch (e) { return }
    }

    public deviceCallRes(device: string, action: string, payload: string, invoker: string, severity: string, pageTitle: string, isUrgentTrace: boolean) {
        try {
            const reqParams = { Device: device, Action: action, Payload: payload, Invoker: invoker, Severity: severity, IsUrgentTrace: isUrgentTrace, PageName: pageTitle, };
            return this.appManagerService.callSignalR(TraceService.CONST_KEY, TraceService.CONST_CLASSNAME, 'DeviceCallRes', JSON.stringify(reqParams))
                .then((result: IAppManagerResponse) => {
                    return result;
                });
        } catch (e) { return }
    }

    public info(message: string, invoker: string, severity: string, pageTitle: string, isUrgentTrace: boolean) {
        try {
            const reqParams = { Message: message, Invoker: invoker, Severity: severity, IsUrgentTrace: isUrgentTrace, PageName: pageTitle, };
            return this.appManagerService.callSignalR(TraceService.CONST_KEY, TraceService.CONST_CLASSNAME, 'Info', JSON.stringify(reqParams))
                .then((result: IAppManagerResponse) => {
                    console.log(result);
                    return result;
                });
        } catch (e) { return }
    }


    public error(message: string, invoker: string, severity: string, pageTitle: string, isUrgentTrace: boolean) {
        try {
            const reqParams = { Message: message, Invoker: invoker, Severity: severity, IsUrgentTrace: isUrgentTrace, PageName: pageTitle, };
            return this.appManagerService.callSignalR(TraceService.CONST_KEY, TraceService.CONST_CLASSNAME, 'Error', JSON.stringify(reqParams))
                .then((result: IAppManagerResponse) => {
                    return result;
                });
        } catch (e) { return }
    }

    public sessionEnd(invoker: string, severity: string, pageTitle: string, isUrgentTrace: boolean) {
        try {
            const reqParams = { Invoker: invoker, Severity: severity, IsUrgentTrace: isUrgentTrace, PageName: pageTitle, };
            return this.appManagerService.callSignalR(TraceService.CONST_KEY, TraceService.CONST_CLASSNAME, 'SessionEnd', JSON.stringify(reqParams))
                .then((result: IAppManagerResponse) => {
                    return result;
                });
        } catch (e) { return }
    }
}
